import { RowOperators } from '../enums/row-operators';
import { FilterOperators } from '../enums/filter-operators';
import { ColumnInfo } from './column-info';

export class FilterInfo {
  column: ColumnInfo;
  value: any;
  valueType: any;
  rowOperator: RowOperators;
  operator: FilterOperators; // FilterOperator
  secondValue: any;
  secondValueType: any;
  valueAlternative: any;
  secondValueAlternative: any;
  lookupValue?: any;
  enumValue?: any;

  constructor(columnInfo: ColumnInfo,
              value: any,
              rowOp: RowOperators,
              op: FilterOperators,
              secondValue?: any,
              valueType?: any,
              secondValueType?: any,
              valueAlternative?: any,
              secondValueAlternative?: any,
              lookupValue?: any,
              enumValue?: any) {
    this.column = columnInfo;
    this.value = value;
    this.valueType = valueType;
    this.valueAlternative = valueAlternative;
    this.rowOperator = rowOp;
    this.operator = op;
    this.secondValue = secondValue;
    this.secondValueType = secondValueType;
    this.secondValueAlternative = secondValueAlternative;
    this.lookupValue = lookupValue;
    this.enumValue = enumValue;
  }
}
